import React from 'react'
import ReactDOM from 'react-dom/client'
import AdminApp from './AdminApp.tsx'
import './src/index.css'
import { Toaster } from '@shared/components/ui/toaster'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AdminApp />
    <Toaster />
  </React.StrictMode>,
)